'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _dec2, _class3, _dec3, _class4, _dec4, _class5, _dec5, _class6, _dec6, _class7, _dec7, _class8, _dec8, _dec9, _class9, _class10, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactLoader = require('react-loader');

var _reactLoader2 = _interopRequireDefault(_reactLoader);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactFlexboxGrid = require('react-flexbox-grid');

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

var _convert = require('../../helpers/convert');

var _convert2 = _interopRequireDefault(_convert);

var _analytics = require('../../helpers/analytics');

var _analytics2 = _interopRequireDefault(_analytics);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _components = require('../../components');

var _search = require('redux/modules/search');

var searchActions = _interopRequireWildcard(_search);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Styles = require('./Family.css');

/**
 * <FamilyResults
 *   fundFamily
 * />
 *
 * Displays results for major fund families. Includes a chart, category
 * breakdowns, tweet button, and stats on ESG and fossil-free funds. Category
 * breakdowns are rendered by <FamilyResultsSectorDetails />.
 *
 */
var FamilyResults = (_dec = (0, _reactCssModules2.default)(Styles, { allowMultiple: true }), _dec(_class = function (_Component) {
  (0, _inherits3.default)(FamilyResults, _Component);

  function FamilyResults(props) {
    (0, _classCallCheck3.default)(this, FamilyResults);

    var _this = (0, _possibleConstructorReturn3.default)(this, (FamilyResults.__proto__ || (0, _getPrototypeOf2.default)(FamilyResults)).call(this, props));

    _this.getChartData = function (fam) {
      var chartFossil = '#333';
      var chartGray = '#D5D5D5';
      return [{
        value: fam.ff_all_asset_sum,
        label: 'Fossil fuel stocks: ' + _format2.default.perc(fam.ff_all_weight_total),
        color: chartFossil
      }, {
        value: fam.equity_fund_net_assets - fam.ff_all_asset_sum,
        label: 'All other holdings',
        color: chartGray
      }];
    };

    _this.state = {
      fundFamily: props.fundFamily || null
    };
    return _this;
  }

  (0, _createClass3.default)(FamilyResults, [{
    key: 'render',
    value: function render() {
      var fundFamily = this.state.fundFamily;

      if (!fundFamily) {
        return null;
      }

      // styles
      var sriGreen = fundFamily.num_e_sri > 0 ? '-green' : '-black';
      var badgersGreen = fundFamily.num_five_badgers > 0 ? '-green' : '-black';

      // urls
      var safeName = encodeURIComponent(fundFamily.fund_family_label);
      var urlBase = _config2.default.routes.list + '?ff=' + safeName;
      var sriUrl = urlBase + '&dsc=false&sri=1&srt=grade_fossil';
      var badgerUrl = urlBase + '&fffgrd=1&srt=ussif';

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { styleName: 'family-cta' },
          _react2.default.createElement(
            'b',
            null,
            'Major fund managers are pouring trillions into fossil fuel investments.'
          ),
          _react2.default.createElement('br', null),
          'Share to spread the word that business as usual is fueling climate destruction.'
        ),
        _react2.default.createElement(_components.Tweeter, {
          type: 'family',
          item: fundFamily
        }),
        _react2.default.createElement(
          'div',
          { styleName: 'family-cta-social-buttons-wrap' },
          _react2.default.createElement(_components.SocialButtons, {
            message: _config2.default.app.title + ' - ' + fundFamily.name,
            link: _config2.default.routes.families + '?q=' + this.state.family
          })
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'chart-content-hl-wrap' },
          _react2.default.createElement(
            'h2',
            { styleName: 'chart-content-hl' },
            'Equity funds'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-info-circle', nospace: true }),
            '\xA0 This data covers open-end mutual funds and exchange-traded funds domiciled in the U.S. with at least 50% of assets invested in stocks. It excludes bond funds, target date funds, and other investment vehicles like closed-end funds, collective trusts, and funds domiciled outside the U.S. ',
            _react2.default.createElement(
              'b',
              null,
              'This asset manager may have additional fossil fuel investments in those excluded funds.'
            )
          )
        ),
        _react2.default.createElement(
          _reactFlexboxGrid.Row,
          null,
          _react2.default.createElement(
            _reactFlexboxGrid.Col,
            { xs: 12, sm: 12, md: 4, styleName: 'chart-sidebar-wrap' },
            _react2.default.createElement(_components.Chart, {
              currency: 'US Dollar',
              invested: _convert2.default.int(fundFamily.ff_all_asset_sum),
              chartData: this.getChartData(fundFamily)
            }),
            _react2.default.createElement(_components.FlaggedFund, {
              isFamily: true,
              totalFunds: _convert2.default.int(fundFamily.num_equity_funds),
              count: _convert2.default.int(fundFamily.ff_all_count_sum),
              weight: _convert2.default.float(fundFamily.ff_all_weight_total)
            })
          ),
          _react2.default.createElement(
            _reactFlexboxGrid.Col,
            { xs: 12, sm: 12, md: 8, styleName: 'main-content-wrap' },
            _react2.default.createElement(
              'div',
              { styleName: 'sector-details-info-label-energy' },
              _react2.default.createElement(
                'strong',
                null,
                'Producers'
              ),
              ' ',
              _react2.default.createElement(
                'small',
                null,
                _react2.default.createElement(
                  'i',
                  null,
                  'energy sector'
                )
              )
            ),
            _react2.default.createElement(FamilyResultsSectorDetails, {
              type: 'c2',
              label: 'Top 200 owners of carbon reserves',
              sublabel: 'Carbon Underground 200\u2122',
              count: fundFamily.c2_count_sum,
              weight: fundFamily.c2_weight_total,
              asset: fundFamily.c2_asset_sum,
              currency: 'US Dollar'
            }),
            _react2.default.createElement(FamilyResultsSectorDetails, {
              type: 'co',
              label: 'Coal industry',
              sublabel: 'Coal miners, coal services, owners of coal reserves',
              count: fundFamily.co_count_sum,
              weight: fundFamily.co_weight_total,
              asset: fundFamily.co_asset_sum,
              currency: 'US Dollar'
            }),
            _react2.default.createElement(FamilyResultsSectorDetails, {
              type: 'og',
              label: 'Oil/Gas industry',
              sublabel: 'Oil/gas producers and refiners, oil field services and equipment companies, and pipeline operators',
              count: fundFamily.og_count_sum,
              weight: fundFamily.og_weight_total,
              asset: fundFamily.og_asset_sum,
              currency: 'US Dollar'
            }),
            _react2.default.createElement(
              'div',
              { styleName: 'sector-details-info-label-utility' },
              _react2.default.createElement(
                'strong',
                null,
                'Consumers'
              ),
              ' ',
              _react2.default.createElement(
                'small',
                null,
                _react2.default.createElement(
                  'i',
                  null,
                  'utility sector'
                )
              )
            ),
            _react2.default.createElement(FamilyResultsSectorDetails, {
              type: 'f5',
              label: 'Top 50 coal-fired utilities',
              sublabel: 'Macroclimate\xAE 50',
              count: fundFamily.mc50_count_sum,
              weight: fundFamily.mc50_weight_total,
              asset: fundFamily.mc50_asset_sum,
              currency: 'US Dollar'
            }),
            _react2.default.createElement(FamilyResultsSectorDetails, {
              type: 'ut',
              label: 'Fossil-fired utilities',
              sublabel: 'Utilities burning fossil fuels or distributing gas',
              count: fundFamily.ut_count_sum,
              weight: fundFamily.ut_weight_total,
              asset: fundFamily.ut_asset_sum,
              currency: 'US Dollar'
            }),
            _react2.default.createElement(
              'div',
              { styleName: 'sector-details-info' },
              'For each fossil fuel category, we show the combined exposure of the asset manager\'s U.S.-based equity funds.'
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'good-fund-counts-row' },
          _react2.default.createElement(
            'div',
            { styleName: 'good-fund-counts-col' },
            _react2.default.createElement(
              _reactFlexboxGrid.Row,
              null,
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { xs: 12, sm: 8, md: 9 },
                _react2.default.createElement(
                  'div',
                  { styleName: 'good-fund-counts-title' },
                  'Funds with sustainability mandates'
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'good-fund-counts-info' },
                  'Number of ',
                  fundFamily.fund_family_label,
                  ' funds that are marked as having sustainability mandates by Morningstar'
                )
              ),
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { xs: 12, sm: 4, md: 3 },
                _react2.default.createElement(
                  'div',
                  { styleName: 'good-fund-counts-result-and-link-wrap' },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'good-fund-counts-value' + sriGreen },
                    fundFamily.num_e_sri,
                    fundFamily.num_e_sri === 0 ? _react2.default.createElement(
                      'small',
                      null,
                      '\xA0funds'
                    ) : null
                  ),
                  fundFamily.num_e_sri > 0 ? _react2.default.createElement(
                    _components.Link,
                    {
                      to: sriUrl,
                      title: 'Sustainability-mandated ' + fundFamily.fund_family_label + ' funds',
                      xstrong: true
                    },
                    'See funds',
                    _react2.default.createElement(_components.LinkIcon, null)
                  ) : null
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'good-fund-counts-col' },
            _react2.default.createElement(
              _reactFlexboxGrid.Row,
              null,
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { xs: 12, sm: 8, md: 9 },
                _react2.default.createElement(
                  'div',
                  { styleName: 'good-fund-counts-title' },
                  '"A grade" fossil free funds'
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'good-fund-counts-info' },
                  'Number of ',
                  fundFamily.fund_family_label,
                  ' funds that earn a fossil fuel grade of A'
                )
              ),
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { xs: 12, sm: 4, md: 3 },
                _react2.default.createElement(
                  'div',
                  { styleName: 'good-fund-counts-result-and-link-wrap' },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'good-fund-counts-value' + badgersGreen },
                    fundFamily.num_five_badgers,
                    fundFamily.num_five_badgers === 0 ? _react2.default.createElement(
                      'small',
                      null,
                      '\xA0funds'
                    ) : null
                  ),
                  fundFamily.num_five_badgers > 0 ? _react2.default.createElement(
                    _components.Link,
                    {
                      to: badgerUrl,
                      title: 'A grade ' + fundFamily.fund_family_label + ' funds',
                      xstrong: true
                    },
                    'See funds',
                    _react2.default.createElement(_components.LinkIcon, null)
                  ) : null
                )
              )
            )
          )
        )
      );
    }
  }]);
  return FamilyResults;
}(_react.Component)) || _class);

/**
 * <FamilyResultsSectorDetails
 *   type
 *   label
 *   sublabel
 *   count
 *   weight
 *   asset
 *   currency
 * />
 *
 * Displays details for a fossil fuel sector, like Carbon Underground 200.
 * Depending on the sector, displays a different icon. Displays label,
 * sublabel, count, weight, asset provided by props.
 *
 */

var FamilyResultsSectorDetails = (_dec2 = (0, _reactCssModules2.default)(Styles, { allowMultiple: true }), _dec2(_class3 = function (_Component2) {
  (0, _inherits3.default)(FamilyResultsSectorDetails, _Component2);

  function FamilyResultsSectorDetails(props) {
    (0, _classCallCheck3.default)(this, FamilyResultsSectorDetails);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (FamilyResultsSectorDetails.__proto__ || (0, _getPrototypeOf2.default)(FamilyResultsSectorDetails)).call(this, props));

    _this2.state = {
      type: _this2.props.type || null,
      label: _this2.props.label || null,
      sublabel: _this2.props.sublabel || null,
      count: _this2.props.count || null,
      weight: _this2.props.weight || null,
      asset: _this2.props.asset || null,
      currency: _this2.props.currency || null
    };
    return _this2;
  }

  (0, _createClass3.default)(FamilyResultsSectorDetails, [{
    key: 'render',
    value: function render() {
      var _state = this.state,
          type = _state.type,
          label = _state.label,
          sublabel = _state.sublabel,
          count = _state.count,
          weight = _state.weight,
          asset = _state.asset,
          currency = _state.currency;

      // circle icon

      var iconNormal = require('../../../static/images/icn-' + type + '.svg');
      // circle icon inactive
      var iconClean = require('../../../static/images/icn-' + type + '-inactive.svg');
      // clean or dirty?
      var isDirty = _convert2.default.int(count);
      // what style?
      var currIcon = null;
      var cleanDirtyStyle = '';

      if (isDirty) {
        cleanDirtyStyle = 'detail-sector-' + type + '-active';
        currIcon = iconNormal;
      } else {
        cleanDirtyStyle = 'detail-sector-clean';
        currIcon = iconClean;
      }

      return _react2.default.createElement(
        'div',
        { styleName: 'detail-sector-wrapper' },
        _react2.default.createElement(
          'div',
          { styleName: cleanDirtyStyle },
          _react2.default.createElement(
            'div',
            { styleName: 'detail-sector-detail-icon-wrap' },
            _react2.default.createElement('img', {
              styleName: 'detail-icon',
              src: currIcon,
              alt: label
            })
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'detail-title-active' },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'b',
                null,
                label
              )
            ),
            sublabel ? _react2.default.createElement(
              'div',
              { styleName: 'detail-sublabel' },
              sublabel
            ) : null
          ),
          isDirty ? _react2.default.createElement(
            'div',
            { styleName: 'detail-sector-stat-wrapper' },
            _react2.default.createElement(
              'div',
              { styleName: 'detail-stat-active' },
              _react2.default.createElement(
                'div',
                { styleName: 'detail-stat-figure' },
                _format2.default.number(count)
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'detail-stat-label' },
                'holdings'
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'detail-stat-active' },
              _react2.default.createElement(
                'div',
                { styleName: 'detail-stat-figure' },
                _format2.default.money(asset, true, currency, true)
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'detail-stat-label' },
                'invested'
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'detail-stat-active' },
              _react2.default.createElement(
                'div',
                { styleName: 'detail-stat-figure' },
                _format2.default.perc(weight)
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'detail-stat-label' },
                'of fund assets'
              )
            )
          ) : _react2.default.createElement(
            'div',
            { styleName: 'single-badge-wrap' },
            _react2.default.createElement(
              'div',
              { styleName: 'single-badge-text' },
              _react2.default.createElement(
                'div',
                { styleName: 'single-badge-subtitle' },
                'No direct stock holdings'
              )
            )
          )
        )
      );
    }
  }]);
  return FamilyResultsSectorDetails;
}(_react.Component)) || _class3);

/**
 * <FamilyBanner
 *   fundFamily
 * />
 *
 * Displays a banner for the fund family that has a different tagline if the
 * family is one of the 10 families with additional data in config, or just
 * a generic fund family.
 *
 */

var FamilyBanner = (_dec3 = (0, _reactCssModules2.default)(Styles, { allowMultiple: true }), _dec3(_class4 = function (_Component3) {
  (0, _inherits3.default)(FamilyBanner, _Component3);

  function FamilyBanner(props) {
    (0, _classCallCheck3.default)(this, FamilyBanner);

    var _this3 = (0, _possibleConstructorReturn3.default)(this, (FamilyBanner.__proto__ || (0, _getPrototypeOf2.default)(FamilyBanner)).call(this, props));

    _this3.state = {
      fundFamily: props.fundFamily || null
    };
    return _this3;
  }

  (0, _createClass3.default)(FamilyBanner, [{
    key: 'render',
    value: function render() {
      var fundFamily = this.state.fundFamily;

      if (!fundFamily) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { styleName: 'banner-wrap' },
        _react2.default.createElement(
          'div',
          { styleName: 'banner' },
          _react2.default.createElement(
            'div',
            { styleName: 'banner-inner' },
            _react2.default.createElement(
              'div',
              { styleName: 'banner-taglines' },
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'div',
                  { styleName: 'banner-tagline' },
                  fundFamily ? _react2.default.createElement(
                    'span',
                    null,
                    'Are your retirement funds'
                  ) : _react2.default.createElement(
                    'span',
                    null,
                    'Your retirement plan could'
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'div',
                  { styleName: 'banner-tagline' },
                  fundFamily ? _react2.default.createElement(
                    'span',
                    null,
                    'invested with ',
                    fundFamily.fund_family_label,
                    '?'
                  ) : _react2.default.createElement(
                    'span',
                    null,
                    'help fund climate solutions'
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'toolkit' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'toolkit-info' },
                  'Check out our action toolkit and talk to your retirement plan manager'
                ),
                _react2.default.createElement(
                  _components.Link,
                  {
                    to: _config2.default.routes.toolkit,
                    log: _analytics2.default.eventToToolkit(),
                    title: 'Fossil free action toolkit' },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'toolkit-action' },
                    'Action toolkit',
                    _react2.default.createElement(_components.LinkIcon, null)
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return FamilyBanner;
}(_react.Component)) || _class4);

/**
 * <FamilySummarySentence
 *   fundFamily
 * />
 *
 * Displays sentence for the fund family that names the fund company
 * at the top of the list of funds and shareclasses for this family.
 *
 */

var FamilySummarySentence = (_dec4 = (0, _reactCssModules2.default)(Styles, { allowMultiple: true }), _dec4(_class5 = function (_Component4) {
  (0, _inherits3.default)(FamilySummarySentence, _Component4);

  function FamilySummarySentence(props) {
    (0, _classCallCheck3.default)(this, FamilySummarySentence);

    var _this4 = (0, _possibleConstructorReturn3.default)(this, (FamilySummarySentence.__proto__ || (0, _getPrototypeOf2.default)(FamilySummarySentence)).call(this, props));

    _this4.state = {
      fundFamily: props.fundFamily || null
    };
    return _this4;
  }

  (0, _createClass3.default)(FamilySummarySentence, [{
    key: 'render',
    value: function render() {
      var fundFamily = this.state.fundFamily;

      if (!fundFamily) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { styleName: 'summary' },
        fundFamily.fund_family_label,
        ' funds in our database'
      );
    }
  }]);
  return FamilySummarySentence;
}(_react.Component)) || _class5);

/**
 * <FamilyFundList
 *   fundList
 * />
 *
 * Displays a list of funds for this family. Maps a fundList to a list of
 * FamilyFundListItem components.
 *
 */

var FamilyFundList = (_dec5 = (0, _reactCssModules2.default)(Styles, { allowMultiple: true }), _dec5(_class6 = function (_Component5) {
  (0, _inherits3.default)(FamilyFundList, _Component5);

  function FamilyFundList(props) {
    (0, _classCallCheck3.default)(this, FamilyFundList);

    var _this5 = (0, _possibleConstructorReturn3.default)(this, (FamilyFundList.__proto__ || (0, _getPrototypeOf2.default)(FamilyFundList)).call(this, props));

    _this5.state = {
      fundList: props.fundList || null
    };
    return _this5;
  }

  (0, _createClass3.default)(FamilyFundList, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      if (props.fundList) {
        this.setState({
          fundList: props.fundList
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var fundList = this.state.fundList;

      if (!fundList) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { styleName: 'holding-list' },
        fundList.map(function (fund, idx) {
          return _react2.default.createElement(FamilyFundListItem, {
            fund: fund,
            key: 'family-fund-list-item-' + idx
          });
        })
      );
    }
  }]);
  return FamilyFundList;
}(_react.Component)) || _class6);

/**
 * <FamilyFundListItem
 *   fund
 * />
 *
 * Displays a fund in the list of funds for this family. Displays some summary
 * stats. Displays a list of tickers using the FamilyFundListItemTickerLinks
 * component.
 *
 */

var FamilyFundListItem = (_dec6 = (0, _reactCssModules2.default)(Styles, { allowMultiple: true }), _dec6(_class7 = function (_Component6) {
  (0, _inherits3.default)(FamilyFundListItem, _Component6);

  function FamilyFundListItem(props) {
    (0, _classCallCheck3.default)(this, FamilyFundListItem);

    var _this6 = (0, _possibleConstructorReturn3.default)(this, (FamilyFundListItem.__proto__ || (0, _getPrototypeOf2.default)(FamilyFundListItem)).call(this, props));

    _this6.state = {
      fund: props.fund || null
    };
    return _this6;
  }

  (0, _createClass3.default)(FamilyFundListItem, [{
    key: 'render',
    value: function render() {
      var fund = this.state.fund;

      if (!fund) {
        return null;
      }

      var fund_legal_name = fund.fund_legal_name,
          c2f5coogutcount = fund.c2f5coogutcount,
          currency = fund.currency,
          c2f5coogutasset = fund.c2f5coogutasset,
          c2f5coogutweight = fund.c2f5coogutweight,
          grade_fossil = fund.grade_fossil;


      return _react2.default.createElement(
        'div',
        { styleName: 'holding' },
        _react2.default.createElement(
          'div',
          { styleName: 'ticker-name-assets' },
          _react2.default.createElement(
            'div',
            { styleName: 'ticker-name' },
            _react2.default.createElement(
              'div',
              { styleName: 'holdings-name' },
              fund_legal_name
            ),
            _react2.default.createElement(FamilyFundListItemTickerLinks, { shareclasses: fund.shareclass })
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'ticker-assets' },
            _react2.default.createElement(
              'div',
              { styleName: 'ticker-assets-figure' },
              _format2.default.number(c2f5coogutcount)
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'ticker-assets-label' },
              '\xA0fossil fuel stocks'
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'ticker-assets' },
            _react2.default.createElement(
              'div',
              { styleName: 'ticker-assets-figure' },
              _format2.default.money(c2f5coogutasset, true, currency, true)
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'ticker-assets-label' },
              '\xA0invested'
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'ticker-assets' },
            _react2.default.createElement(
              'div',
              { styleName: 'ticker-assets-figure' },
              _format2.default.perc(c2f5coogutweight)
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'ticker-assets-label' },
              '\xA0of portfolio'
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'score-wrapper' },
          _react2.default.createElement(_components.Grade, { grade: grade_fossil, blocksmall: true })
        )
      );
    }
  }]);
  return FamilyFundListItem;
}(_react.Component)) || _class7);

/**
 * <FamilyFundListItemTickerLinks
 *   shareclasses
 * />
 *
 * Displays a list of tickers, linked to those shareclass profiles, for a fund
 * in the fund list. Maps a list of shareclasses to a list of URLs and
 * tickers. Maps the list of URLs and tickers to a list of Links.
 *
 */

var FamilyFundListItemTickerLinks = (_dec7 = (0, _reactCssModules2.default)(Styles, { allowMultiple: true }), _dec7(_class8 = function (_Component7) {
  (0, _inherits3.default)(FamilyFundListItemTickerLinks, _Component7);

  function FamilyFundListItemTickerLinks(props) {
    (0, _classCallCheck3.default)(this, FamilyFundListItemTickerLinks);

    var _this7 = (0, _possibleConstructorReturn3.default)(this, (FamilyFundListItemTickerLinks.__proto__ || (0, _getPrototypeOf2.default)(FamilyFundListItemTickerLinks)).call(this, props));

    _this7.state = {
      shareclasses: props.shareclasses || null
    };
    return _this7;
  }

  (0, _createClass3.default)(FamilyFundListItemTickerLinks, [{
    key: 'render',
    value: function render() {
      var shareclasses = this.state.shareclasses;

      if (!shareclasses) {
        return null;
      }

      var tickerUrls = shareclasses.map(function (e, i) {
        var tckr = e.ticker || 'N/A';
        var safeTicker = e.ticker || 'N';
        var url = _config2.default.routes.fund + '/' + _format2.default.sanitize(e.fund_legal_name) + '/' + safeTicker + '/' + _config2.default.profilePath + '/' + e.fund_id + '/' + e.investment_vehicle_id;

        return {
          ticker: tckr,
          name: e.name,
          url: url
        };
      });

      if (tickerUrls.length === 1 && tickerUrls[0].ticker === 'N/A') {
        var e = tickerUrls[0];
        return _react2.default.createElement(
          'div',
          { styleName: 'ticker-links' },
          _react2.default.createElement(
            _components.Link,
            { to: e.url, title: e.name },
            _react2.default.createElement(
              'span',
              { styleName: 'ticker' },
              'See results',
              _react2.default.createElement(_components.LinkIcon, null)
            )
          )
        );
      }

      return _react2.default.createElement(
        'div',
        { styleName: 'ticker-links' },
        tickerUrls.map(function (e, i) {
          return _react2.default.createElement(
            _components.Link,
            {
              key: 'holding-link-' + i,
              to: e.url,
              title: e.name
            },
            e.ticker === 'N/A' ? _react2.default.createElement(
              'span',
              { styleName: 'ticker' },
              e.name
            ) : _react2.default.createElement(
              'span',
              { styleName: 'ticker' },
              e.ticker
            )
          );
        })
      );
    }
  }]);
  return FamilyFundListItemTickerLinks;
}(_react.Component)) || _class8);

/**
 * <Family />
 *
 * Connects to API and fetches a list of funds for this family.
 *
 */

var Family = (_dec8 = (0, _reactRedux.connect)(function (state) {
  return {
    result: state.familyShareClass.result,
    searching: state.familyShareClass.loading,
    searched: state.familyShareClass.loaded,
    error: state.familyShareClass.error,
    sector: state.sector.result
  };
}, searchActions), _dec9 = (0, _reactCssModules2.default)(Styles, { allowMultiple: true }), _dec8(_class9 = _dec9(_class9 = (_temp = _class10 = function (_Component8) {
  (0, _inherits3.default)(Family, _Component8);

  function Family(props) {
    (0, _classCallCheck3.default)(this, Family);

    var _this8 = (0, _possibleConstructorReturn3.default)(this, (Family.__proto__ || (0, _getPrototypeOf2.default)(Family)).call(this, props));

    _this8.getMoreFunds = function () {
      _this8.familyShareClasses(_this8.state.family, _this8.state.page + 1);
    };

    _this8.familyShareClasses = function (family, page) {
      page = page || _this8.state.page;
      _this8.setState({ page: page });
      _this8.props.familyShareClasses(family, page);
    };

    _this8.configFundFamily = function () {
      return _config2.default.familyFunds.find(function (family) {
        return family.fund_family_label === _this8.state.family;
      });
    };

    _this8.state = {
      page: 1,
      family: props.location.query.q || '',
      searchQuery: '',
      lastResult: null,
      funds: []
    };
    return _this8;
  }

  (0, _createClass3.default)(Family, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (typeof window !== 'undefined') {
        window.scrollTo(0, 0);
      }
      this.familyShareClasses(this.state.family, 1);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      var q = props.location.query.q || '';
      if (q !== this.state.family) {
        this.familyShareClasses(q, 1);
        window.scroll(0, 0);
        this.setState({
          page: 1,
          family: q,
          searchQuery: '',
          lastResult: null,
          funds: []
        });
      } else if (props.result && this.state.lastResult !== props.result) {
        this.setState({
          lastResult: props.result,
          funds: this.state.funds.concat(props.result)
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      if (!(this.state.page !== 1 || !this.props.searching)) {
        return _react2.default.createElement(
          'div',
          { styleName: 'main' },
          _react2.default.createElement(_reactLoader2.default, {
            options: { scale: 0.70, top: '2.0rem' },
            loaded: false
          })
        );
      }

      if (!this.props.location.query.q) {
        return _react2.default.createElement(
          'div',
          { styleName: 'main-page' },
          _react2.default.createElement(_components.FamilyGrid, { fullGrid: true })
        );
      }

      // redirect for SEO
      if (this.props.location.query.q.toUpperCase() === 'BLACKROCK' || this.props.location.query.q.toUpperCase() === 'ISHARES') {
        this.context.router.push(_config2.default.routes.families + '?q=BlackRock%2FiShares');
      }
      // redirect for TSP
      if (this.props.location.query.q.toUpperCase() === 'THRIFT SAVINGS PLAN' || this.props.location.query.q.toUpperCase() === 'THRIFT%20SAVINGS%20PLAN') {
        this.context.router.push(_config2.default.routes.tspLanding);
      }

      var funds = this.state.funds;


      var fundFamily = this.configFundFamily();

      var fileName = _format2.default.imgPath(this.state.family);
      var hasLogo = false;
      var companyLogo = null;
      try {
        companyLogo = require('../../../static/images/fam/' + fileName + '.png');
        hasLogo = true;
      } catch (e) {
        // console.log('')
      }

      var hasMore = this.state.lastResult && this.state.lastResult.length === _config2.default.queryMaxFunds;

      return _react2.default.createElement(
        'div',
        { styleName: 'main' },
        _container2.default.helmet(this.state.family),
        _react2.default.createElement(
          _reactLoader2.default,
          {
            options: { scale: 0.70, top: '2.0rem' },
            loaded: this.state.page !== 1 || !this.props.searching
          },
          _react2.default.createElement(
            'div',
            { styleName: 'name-wrap-background' },
            _react2.default.createElement(
              _components.ContainerDivs,
              null,
              _react2.default.createElement(
                'div',
                { styleName: 'name-wrap' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'name' },
                  _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                      'div',
                      { styleName: fundFamily ? 'name-tag-big' : 'name-tag' },
                      fundFamily ? 'Major fund manager' : 'Fund manager'
                    ),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'name-logo-lbl' },
                      fundFamily ? fundFamily.label : this.state.family
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  null,
                  hasLogo ? _react2.default.createElement('img', {
                    styleName: 'name-logo-img',
                    src: companyLogo,
                    alt: fundFamily ? fundFamily.label : this.state.family
                  }) : null
                )
              )
            )
          ),
          _react2.default.createElement(
            _components.ContainerDivs,
            null,
            _react2.default.createElement(FamilyResults, { fundFamily: fundFamily })
          ),
          fundFamily ? _react2.default.createElement(FamilyBanner, { fundFamily: fundFamily }) : null,
          _react2.default.createElement(
            'div',
            { styleName: 'holdings-wrapper' },
            _react2.default.createElement(
              'div',
              { styleName: 'holdings' },
              _react2.default.createElement(FamilySummarySentence, { fundFamily: fundFamily }),
              _react2.default.createElement(
                'div',
                { styleName: 'holdings-inner' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'rating-label' },
                  _react2.default.createElement('div', { styleName: 'rating-label-line' }),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'rating-label-info' },
                    'Fossil fuel grade'
                  )
                ),
                _react2.default.createElement(FamilyFundList, { fundList: funds })
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'more-funds-wrapper' },
            _react2.default.createElement(_reactLoader2.default, {
              options: { scale: 0.70, top: '0' },
              loaded: !this.props.searching
            }),
            _react2.default.createElement(
              'div',
              { styleName: 'more-funds' },
              _react2.default.createElement(
                'div',
                {
                  onClick: hasMore ? this.getMoreFunds : null,
                  styleName: hasMore ? 'more-funds-button' : 'no-more-funds-button'
                },
                hasMore ? 'See more funds' : 'No more funds',
                hasMore ? _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-plus-circle' }) : null
              ),
              !hasMore ? _react2.default.createElement(
                'div',
                { styleName: 'no-more-funds-info' },
                'Looking for your favorite fund and can\'t find it? Sorry, but we don\'t have everything in our database.'
              ) : null
            )
          ),
          _react2.default.createElement(_components.GetStartedInput, null),
          !fundFamily ? _react2.default.createElement(FamilyBanner, { fundFamily: fundFamily }) : null,
          _react2.default.createElement(
            'div',
            { styleName: 'signup-wrap' },
            _react2.default.createElement(
              'div',
              { styleName: 'signup-modal' },
              _react2.default.createElement(_components.AboutBanner, null)
            )
          )
        )
      );
    }
  }]);
  return Family;
}(_react.Component), _class10.propTypes = {
  searching: _react.PropTypes.bool,
  searched: _react.PropTypes.bool,
  error: _react.PropTypes.object,
  result: _react.PropTypes.array
}, _class10.contextTypes = {
  router: _react.PropTypes.object.isRequired
}, _temp)) || _class9) || _class9);
exports.default = Family;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Family/Family.js
// module id = 1400
// module chunks = 0